import {Component, DoCheck, OnInit, Renderer2} from '@angular/core';
import {clearAllDynamicIndicatorNormalUserKeys, UserStateService} from './auth/user-state-service';
import {AuthService} from './auth/auth.service';
import {Title} from '@angular/platform-browser';
import {environment} from '../environments/environment';
import {state} from '@angular/animations';
import {Router} from '@angular/router';
import {PageTitleService} from './core/services/page-title.service';
import {DialogSessionManagerService} from './core/services/dialog-session-manager.service';

@Component({
    selector: 'map-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    private static readonly DEFAULT_PAGE_TITLE = 'Maptycs';
    private static readonly DEFAULT_FAVICON = 'favicon.png';
    principal;
    favicon: HTMLLinkElement = document.querySelector('#favicon');

    constructor(private readonly userStateService: UserStateService,
                private readonly titleService: Title,private readonly router: Router,
                private readonly authService: AuthService,
                private renderer: Renderer2,
                private readonly pageTitleService: PageTitleService,
                private readonly dialogSessionManager: DialogSessionManagerService) {
        this.titleService.setTitle(environment.pageTitle || AppComponent.DEFAULT_PAGE_TITLE);
        if (environment.customFavicon) {
            this.favicon.href = environment.customFavicon;
        }
    }

    ngOnInit(): void {
        
        this.principal = this.authService.getPrincipal();
        if (this.principal) {
            this.userStateService.initialize(this.principal);
        }

        const script = this.renderer.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${environment.recaptchaSiteKey}`;
        this.renderer.appendChild(document.head, script);

        console.log('App component INIT. for test only');
        this.handleManualPageRefresh();
        
        // Initialize dynamic page title tracking for GA4
        this.pageTitleService.init();
        
        // Initialize dialog session manager for cross-tab session handling
        this.dialogSessionManager.initialize();
    }

    handleManualPageRefresh(): void {
        const perfEntries = performance.getEntriesByType('navigation');
        if (perfEntries && perfEntries.length > 0) {
            const navEntry = perfEntries[0] as PerformanceNavigationTiming;
            if (navEntry.type === 'reload') {
                clearAllDynamicIndicatorNormalUserKeys();
            }
        }
    }
}
